import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mpkrpvglaujyhvjgzihj.supabase.co'
const supabaseKey = 'sb_publishable_fYiqmuTySqaxR09XTNwFug_bHmnz2a1'

// Client principale — usato da dashboard ristorante e app cliente
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'gustly-session',
  }
})

// Client admin — sessione separata, non sovrascrive quella del ristorante
// Permette di tenere aperto /admin e /dashboard contemporaneamente
export const supabaseAdmin = createClient(supabaseUrl, supabaseKey, {
  auth: {
    storageKey: 'gustly-admin-session',
  }
})
